/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const activitySchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-usages-domain:Activity',
    type: 'object',
    properties: {
        activityID: { type: 'string', uid: 9 },
        activityType: { type: 'string', enum: ['usage', 'credit'] },
        date: { type: 'string', format: 'date-time' },
        value: { type: 'number' },
        details: { type: 'array', items: { type: 'string', minLength: 1 } },
        orgID: { type: 'string', minLength: 0, maxLength: 128 },
        userID: { type: 'string', minLength: 0, maxLength: 128 },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] }
    },
    required: ['activityID', 'activityType', 'date', 'value', 'details']
};
const func2 = ucs2length;
const func3 = base64urlToBuffer;
const func4 = base64urlEncode;
const func5 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func6 = ucs2length;
const formats0 = formatWrapper['date-time'];
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-usages-domain:Activity" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.activityID === undefined && (missing0 = 'activityID')) ||
                (data.activityType === undefined && (missing0 = 'activityType')) ||
                (data.date === undefined && (missing0 = 'date')) ||
                (data.value === undefined && (missing0 = 'value')) ||
                (data.details === undefined && (missing0 = 'details'))) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.activityID !== undefined) {
                    let data0 = data.activityID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func2(data0) < b64min0 || func2(data0) > b64max0) {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/activityID',
                                        schemaPath: '#/properties/activityID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func2(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func2(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func3(data0);
                                if (decoded0.length !== 9) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/activityID',
                                            schemaPath: '#/properties/activityID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func4(decoded0);
                                    if (func5(encoded0) !== func5(data0)) {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/activityID',
                                                schemaPath: '#/properties/activityID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/activityID',
                                    schemaPath: '#/properties/activityID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.activityType !== undefined) {
                        let data1 = data.activityType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/activityType',
                                    schemaPath: '#/properties/activityType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'usage' || data1 === 'credit')) {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/activityType',
                                    schemaPath: '#/properties/activityType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema29.properties.activityType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.date !== undefined) {
                            let data2 = data.date;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.validate(data2)) {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/date',
                                                    schemaPath: '#/properties/date/format',
                                                    keyword: 'format',
                                                    params: { format: 'date-time' },
                                                    message: 'must match format "' + 'date-time' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/date',
                                                schemaPath: '#/properties/date/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.value !== undefined) {
                                const _errs7 = errors;
                                if (!(typeof data.value == 'number')) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/value',
                                            schemaPath: '#/properties/value/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.details !== undefined) {
                                    let data4 = data.details;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (Array.isArray(data4)) {
                                            var valid2 = true;
                                            const len0 = data4.length;
                                            for (let i0 = 0; i0 < len0; i0++) {
                                                let data5 = data4[i0];
                                                const _errs11 = errors;
                                                if (errors === _errs11) {
                                                    if (typeof data5 === 'string') {
                                                        if (func6(data5) < 1) {
                                                            validate12.errors = [
                                                                {
                                                                    instancePath: instancePath + '/details/' + i0,
                                                                    schemaPath: '#/properties/details/items/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate12.errors = [
                                                            {
                                                                instancePath: instancePath + '/details/' + i0,
                                                                schemaPath: '#/properties/details/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs11 === errors;
                                                if (!valid2) {
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/details',
                                                    schemaPath: '#/properties/details/type',
                                                    keyword: 'type',
                                                    params: { type: 'array' },
                                                    message: 'must be array'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.orgID !== undefined) {
                                        let data6 = data.orgID;
                                        const _errs13 = errors;
                                        if (errors === _errs13) {
                                            if (typeof data6 === 'string') {
                                                if (func6(data6) > 128) {
                                                    validate12.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgID',
                                                            schemaPath: '#/properties/orgID/maxLength',
                                                            keyword: 'maxLength',
                                                            params: { limit: 128 },
                                                            message: 'must NOT have more than 128 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (func6(data6) < 0) {
                                                        validate12.errors = [
                                                            {
                                                                instancePath: instancePath + '/orgID',
                                                                schemaPath: '#/properties/orgID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 0 },
                                                                message: 'must NOT have fewer than 0 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            else {
                                                validate12.errors = [
                                                    {
                                                        instancePath: instancePath + '/orgID',
                                                        schemaPath: '#/properties/orgID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs13 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.userID !== undefined) {
                                            let data7 = data.userID;
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (typeof data7 === 'string') {
                                                    if (func6(data7) > 128) {
                                                        validate12.errors = [
                                                            {
                                                                instancePath: instancePath + '/userID',
                                                                schemaPath: '#/properties/userID/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 128 },
                                                                message: 'must NOT have more than 128 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (func6(data7) < 0) {
                                                            validate12.errors = [
                                                                {
                                                                    instancePath: instancePath + '/userID',
                                                                    schemaPath: '#/properties/userID/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 0 },
                                                                    message: 'must NOT have fewer than 0 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate12.errors = [
                                                        {
                                                            instancePath: instancePath + '/userID',
                                                            schemaPath: '#/properties/userID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs15 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.orgPlan !== undefined) {
                                                let data8 = data.orgPlan;
                                                const _errs17 = errors;
                                                if (typeof data8 !== 'string') {
                                                    validate12.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgPlan',
                                                            schemaPath: '#/properties/orgPlan/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data8 === 'Social' ||
                                                    data8 === 'Enterprise' ||
                                                    data8 === 'Integration' ||
                                                    data8 === 'Temp' ||
                                                    data8 === 'Starter' ||
                                                    data8 === 'Professional')) {
                                                    validate12.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgPlan',
                                                            schemaPath: '#/properties/orgPlan/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema29.properties.orgPlan.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const creditActivitySchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-usages-domain:CreditActivity',
    type: 'object',
    properties: {
        isCreditReset: { type: 'boolean' },
        previousCredit: { type: 'number' },
        isBonusCredit: { type: 'boolean' }
    },
    required: []
};
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-usages-domain:CreditActivity" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.isCreditReset !== undefined) {
                const _errs1 = errors;
                if (typeof data.isCreditReset !== 'boolean') {
                    validate13.errors = [
                        {
                            instancePath: instancePath + '/isCreditReset',
                            schemaPath: '#/properties/isCreditReset/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean'
                        }
                    ];
                    return false;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.previousCredit !== undefined) {
                    const _errs3 = errors;
                    if (!(typeof data.previousCredit == 'number')) {
                        validate13.errors = [
                            {
                                instancePath: instancePath + '/previousCredit',
                                schemaPath: '#/properties/previousCredit/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.isBonusCredit !== undefined) {
                        const _errs5 = errors;
                        if (typeof data.isBonusCredit !== 'boolean') {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/isBonusCredit',
                                    schemaPath: '#/properties/isBonusCredit/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const creditEventSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-usages-domain:CreditEvent',
    type: 'object',
    properties: { orgID: { type: 'string', format: 'uuid' }, credit: { type: 'number' } },
    required: ['orgID', 'credit']
};
const formats2 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-usages-domain:CreditEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) || (data.credit === undefined && (missing0 = 'credit'))) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.test(data0)) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.credit !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.credit == 'number')) {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/credit',
                                    schemaPath: '#/properties/credit/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const creditInfoSchemaValidation = validate15;
const schema32 = {
    $id: 'urn:wisepipe-usages-domain:CreditInfo',
    type: 'object',
    properties: {
        credit: { type: 'number' },
        completedSurvey: { type: 'boolean' },
        addedBonusCreditTypes: { type: 'array', items: { type: 'string', enum: ['hubspot'] } }
    },
    required: ['credit']
};
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-usages-domain:CreditInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.credit === undefined && (missing0 = 'credit')) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.credit !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.credit == 'number')) {
                        validate15.errors = [
                            {
                                instancePath: instancePath + '/credit',
                                schemaPath: '#/properties/credit/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.completedSurvey !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.completedSurvey !== 'boolean') {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/completedSurvey',
                                    schemaPath: '#/properties/completedSurvey/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.addedBonusCreditTypes !== undefined) {
                            let data2 = data.addedBonusCreditTypes;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data3 = data2[i0];
                                        const _errs7 = errors;
                                        if (typeof data3 !== 'string') {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/addedBonusCreditTypes/' + i0,
                                                    schemaPath: '#/properties/addedBonusCreditTypes/items/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data3 === 'hubspot')) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/addedBonusCreditTypes/' + i0,
                                                    schemaPath: '#/properties/addedBonusCreditTypes/items/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema32.properties.addedBonusCreditTypes.items.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/addedBonusCreditTypes',
                                            schemaPath: '#/properties/addedBonusCreditTypes/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const usageActivitySchemaValidation = validate16;
const schema33 = {
    $id: 'urn:wisepipe-usages-domain:UsageActivity',
    type: 'object',
    properties: { charge: { type: 'number' }, lastRefresh: { type: 'string', format: 'date-time' } },
    required: []
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-usages-domain:UsageActivity" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.charge !== undefined) {
                const _errs1 = errors;
                if (!(typeof data.charge == 'number')) {
                    validate16.errors = [
                        {
                            instancePath: instancePath + '/charge',
                            schemaPath: '#/properties/charge/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number'
                        }
                    ];
                    return false;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.lastRefresh !== undefined) {
                    let data1 = data.lastRefresh;
                    const _errs3 = errors;
                    if (errors === _errs3) {
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (!formats0.validate(data1)) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/lastRefresh',
                                            schemaPath: '#/properties/lastRefresh/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/lastRefresh',
                                        schemaPath: '#/properties/lastRefresh/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const usageInputSchemaValidation = validate17;
const schema34 = {
    $id: 'urn:wisepipe-usages-domain:UsageInput',
    type: 'object',
    properties: {
        stream: { type: 'string' },
        userID: { type: 'string', format: 'uuid' },
        orgID: { type: 'string', format: 'uuid' },
        details: { type: 'array', items: { type: 'string', minLength: 1 } },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] }
    },
    required: ['stream', 'userID', 'orgID', 'details']
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-usages-domain:UsageInput" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.stream === undefined && (missing0 = 'stream')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.details === undefined && (missing0 = 'details'))) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.stream !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.stream !== 'string') {
                        validate17.errors = [
                            {
                                instancePath: instancePath + '/stream',
                                schemaPath: '#/properties/stream/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats2.test(data1)) {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgID !== undefined) {
                            let data2 = data.orgID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats2.test(data2)) {
                                            validate17.errors = [
                                                {
                                                    instancePath: instancePath + '/orgID',
                                                    schemaPath: '#/properties/orgID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.details !== undefined) {
                                let data3 = data.details;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        var valid1 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data4 = data3[i0];
                                            const _errs9 = errors;
                                            if (errors === _errs9) {
                                                if (typeof data4 === 'string') {
                                                    if (func6(data4) < 1) {
                                                        validate17.errors = [
                                                            {
                                                                instancePath: instancePath + '/details/' + i0,
                                                                schemaPath: '#/properties/details/items/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/details/' + i0,
                                                            schemaPath: '#/properties/details/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid1 = _errs9 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/details',
                                                schemaPath: '#/properties/details/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.orgPlan !== undefined) {
                                    let data5 = data.orgPlan;
                                    const _errs11 = errors;
                                    if (typeof data5 !== 'string') {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/orgPlan',
                                                schemaPath: '#/properties/orgPlan/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data5 === 'Social' ||
                                        data5 === 'Enterprise' ||
                                        data5 === 'Integration' ||
                                        data5 === 'Temp' ||
                                        data5 === 'Starter' ||
                                        data5 === 'Professional')) {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/orgPlan',
                                                schemaPath: '#/properties/orgPlan/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema34.properties.orgPlan.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs11 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map